import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import "./SeeMore.css";

const SeeMoreButton = ({ expanded, onClick }) => {
  return (
    <button className="see-more-btn" onClick={onClick}>
      <span className="icon">
        {expanded ? <FaChevronUp /> : <FaChevronDown />}
      </span>
      <span className="text">
        {expanded ? "See Less" : "See More"}
      </span>
    </button>
  );
};

export default SeeMoreButton;
